/**
 * 列表模块提交校验：至少一条，并逐条校验必填字段（可选）。
 * @param {string} emptyMessage 无数据提示
 * @param {{ requiredFields?: string[], fieldLabels?: Record<string,string>, moduleLabel?: string }} [options]
 */
export default function studioListValidate(emptyMessage, options) {
  const opts = options || {};
  const requiredFields = opts.requiredFields || [];
  const fieldLabels = opts.fieldLabels || {};
  const moduleLabel = opts.moduleLabel || "";
  return {
    methods: {
      validate() {
        const list = this.dataList || [];
        const pagedTotal =
          this.pagination &&
          typeof this.pagination === "object" &&
          this.pagination.total != null
            ? Number(this.pagination.total)
            : 0;
        if (list.length === 0 && pagedTotal <= 0) {
          this.$message.info(emptyMessage);
          return false;
        }
        if (requiredFields.length && list.length) {
          for (let i = 0; i < list.length; i++) {
            const row = list[i] || {};
            for (let j = 0; j < requiredFields.length; j++) {
              const field = requiredFields[j];
              const val = row[field];
              if (val === null || val === undefined || val === "") {
                const label = fieldLabels[field] || field;
                this.$message.info(
                  `${moduleLabel}第 ${i + 1} 行的${label}没有值，请填写`
                );
                return false;
              }
            }
          }
        }
        return true;
      },
    },
  };
}
